import React, { useContext } from 'react';

import styled from '@emotion/styled';

import useUpdateBusinessInfo from '../../../../hooks/dashboard/settings/useUpdateBusinessInfo';
import {
  UpdateBusinessInfoDataType,
  updateBusinessInfoInitialValues,
  UpdateBusinessInfoSchema,
} from '../../../../models/dashboard/settings/update-business-info';
import { listOfIndustries } from '../../../../pages/Auth/SignUp/SignUpData';
import { useAppSelector } from '../../../../redux/store';
import { FormSubmitButton } from '../../../Button/FormSubmitButton';
import {
  CustomCheckbox,
  CustomCheckboxGroup,
} from '../../../FormCom/CustomCheckBoxField';
import CustomPhoneNumberInputField from '../../../FormCom/CustomPhoneNumberInputField';
import CustomSearchableSelectField from '../../../FormCom/CustomSearchableSelectField';
import CustomSelectField from '../../../FormCom/CustomSelectField';
import { FormComponent } from '../../../FormCom/FormComponent';
import ModalContainer from '../../ModalContainer';
import { ModalContext } from '../../ModalContext';

const fleetSize: Record<string, string> = {
  'Less than 10': '0 - 10',
  '10 - 50': '10 - 50',
  '50 - 100': '50 - 100',
  '100 - 500': '100 - 500',
  'Above 500': '500+',
};

const UpdateBusinessInfoModal = () => {
  const modalContext = useContext(ModalContext);
  const { updateBusinessInfo, loading } = useUpdateBusinessInfo();
  const { businessInfo } = useAppSelector((state) => state.businessInfoData);

  const onSubmit = (value: UpdateBusinessInfoDataType) => {
    updateBusinessInfo(value, () => {
      modalContext?.setShowModal(!modalContext?.showModal);
    });
  };

  if (businessInfo) {
    updateBusinessInfoInitialValues.phoneNumber =
      businessInfo?.phoneNumber ?? '';
    updateBusinessInfoInitialValues.industryType =
      businessInfo?.industryType ?? '';
    updateBusinessInfoInitialValues.fleetSize = businessInfo?.fleetSize ?? '';
    updateBusinessInfoInitialValues.typicalRoute =
      businessInfo?.typicalRoute ?? [];
    updateBusinessInfoInitialValues.deliveryVehicleType =
      businessInfo?.fleetCategories ?? [];
  }

  return (
    <Container>
      <ModalContainer label='Update Business Information'>
        <FormComponent
          initialValues={updateBusinessInfoInitialValues}
          schema={UpdateBusinessInfoSchema}
          onSubmit={onSubmit}
          // className={'small-gap'}
        >
          <CustomPhoneNumberInputField
            label='Phone Number'
            name='phoneNumber'
            id='phoneNumber'
            placeholder='8XXXXXXXX'
            fixedCountry='NG'
            maxLength={10}
          />
          <CustomSearchableSelectField
            label='Industry Type'
            placeholder='Select...'
            name='industryType'
            id='industryType'
            optionData={listOfIndustries}
          />
          <CustomSelectField
            label='Fleet Size'
            placeholder='Select...'
            name='fleetSize'
            id='fleetSize'
            optionData={Object.keys(fleetSize)}
          />

          <CustomCheckboxGroup
            label='Typical Route'
            name='typicalRoute'
            className='row-group slim-error'
          >
            <CustomCheckbox value='Inter State'>Interstate</CustomCheckbox>
            <CustomCheckbox value='Intra State'>Intrastate</CustomCheckbox>
            <CustomCheckbox value='Rural'>Rural</CustomCheckbox>
            <CustomCheckbox value='Long Haul'>Long Haul</CustomCheckbox>
          </CustomCheckboxGroup>

          <CustomCheckboxGroup
            label='Delivery Vehicle Type'
            name='deliveryVehicleType'
            className='row-group slim-error'
          >
            <CustomCheckbox value='Keke'>Auto-rickshaw (Keke)</CustomCheckbox>
            <CustomCheckbox value='Trailer'>Trailer</CustomCheckbox>
            <CustomCheckbox value='Bus'>Bus</CustomCheckbox>
            <CustomCheckbox value='Bicycle'>Bicycle</CustomCheckbox>
            <CustomCheckbox value='Van'>Van</CustomCheckbox>
            <CustomCheckbox value='Bike'>Bike</CustomCheckbox>
            <CustomCheckbox value='Car'>Car</CustomCheckbox>
            <CustomCheckbox value='Tanker'>Tanker</CustomCheckbox>
            <CustomCheckbox value='Truck'>Truck</CustomCheckbox>
          </CustomCheckboxGroup>

          {/*  */}

          <ButtonArea>
            <FormSubmitButton
              className='clear fill text-red large'
              onClick={() => modalContext?.setShowModal(false)}
              btnType='button'
            >
              Cancel
            </FormSubmitButton>
            <FormSubmitButton className='fill large' loading={loading}>
              Approve
            </FormSubmitButton>
          </ButtonArea>
        </FormComponent>
      </ModalContainer>
    </Container>
  );
};

export default UpdateBusinessInfoModal;

const Container = styled.div`
  flex-direction: column;
  display: flex;
`;

const ButtonArea = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 100%;
  gap: 16px;
  margin-top: 16px;
`;
